var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReferFriend = function SvgIconReferFriend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.292 26.25s1.041 0 1.041-1.042c0-1.041-1.041-4.166-5.208-4.166s-5.208 3.125-5.208 4.166 1.041 1.042 1.041 1.042zm-8.31-1.042-.024-.004c.001-.275.174-1.073.792-1.791.575-.675 1.585-1.33 3.375-1.33 1.788 0 2.799.657 3.375 1.33.618.718.79 1.517.792 1.791l-.009.002-.014.002zm4.143-6.25a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166m3.125-2.083a3.124 3.124 0 1 1-6.248 0 3.124 3.124 0 0 1 6.248 0m-7.358 4.458a6 6 0 0 0-1.282-.257 8 8 0 0 0-.735-.034c-4.167 0-5.208 3.125-5.208 4.166q0 1.042 1.041 1.042H17.1a2.3 2.3 0 0 1-.225-1.042c0-1.052.393-2.127 1.135-3.025a5.5 5.5 0 0 1 .882-.85m-2.1.75a5.7 5.7 0 0 0-.959 3.125h-3.125c0-.27.171-1.073.792-1.795.568-.663 1.554-1.309 3.292-1.329m-3.563-4.687a3.125 3.125 0 1 1 6.25 0 3.125 3.125 0 0 1-6.25 0m3.125-2.084a2.083 2.083 0 1 0 0 4.167 2.083 2.083 0 0 0 0-4.166"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 19.5
  })));
};
export default SvgIconReferFriend;